import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Button } from '../../../../../shared/model/enum';

@Component({
  selector: 'app-unlink-alternative-part',
  templateUrl: './unlink-alternative-part.component.html',
  styleUrls: ['./unlink-alternative-part.component.scss']
})
export class UnlinkAlternativePartComponent implements OnInit {
  @Input() title:string;
  @Input() data:any;
  enumButtonName = Button;

  constructor(public activeModal: NgbActiveModal,public toaster: ToastrService,
    ) {}

  ngOnInit(): void {
  }

}
